import { makeStyles } from "@material-ui/core";
import React from "react";
import { CardBase } from "./partials/CardBase";
const useStyles = makeStyles((theme) => ({
    transformCardContainer: {
        "& .cardContainerClass": {
            height: "150px",
        },
        "& .title": {
            textAlign: "left",
            fontSize: "14px",
            lineHeight: "1.3",
            margin: 0,
        },
        "& .cardTextContainer": {
            padding: "8px",
        },
    },
}));
export const StreamFinishedCard = (props) => {
    const { options } = props;
    const classes = useStyles();
    return (React.createElement("div", { className: classes.transformCardContainer },
        React.createElement(CardBase, { imageUrl: options.imageUrl, title: options.title, link: `/replay/${props.options.programId}/${props.options.id}`, partnerTitle: options.partnerTitle })));
};
//# sourceMappingURL=StreamFinishedCard.js.map